import { CheckoutRepository } from "../repository/CheckoutRepository";

export function useCheckout() {
    const data = {}
    const fetch = {}
    const set = {
        upload_tax_exempt: async (params) => {
            return await new CheckoutRepository().uploadTaxExempt(params);
        }
    }
    return [data, fetch, set];
}